import type { ComponentPropsWithoutRef } from "react";
import { useFormContext } from "react-hook-form";
import type { RegisterOptions } from "react-hook-form";

import {
  TextArea,
  type TextAreaProps,
} from "@/react/components/SettingsApp/CompassCompat/TextArea";

export interface FormTextAreaProps extends ComponentPropsWithoutRef<"textarea"> {
  autoSize?: TextAreaProps["autoSize"];
  className?: string;
  name?: string;
  placeholder?: string;
  rows?: number;
  rules?: RegisterOptions;
}

export const FormTextArea = ({
  name = "",
  rules = {},
  placeholder = "",
  className = "",
  rows = 4,
  ...rest
}: FormTextAreaProps) => {
  const { register } = useFormContext();

  const { ref, ...registerProps } = register(name, rules);

  return (
    <TextArea
      ref={ref}
      className={className}
      placeholder={placeholder}
      rows={rows}
      {...registerProps}
      {...rest}
    />
  );
};

FormTextArea.displayName = "Form.TextArea";
